import { Drawer } from "antd";
import { Form, Formik } from "formik";
import { ExclusionSchema } from "../../../validations";
import TextAreaInput from "../../../components/atomic/inputs/TextAreaInput";
import PrimaryButton from "../../../components/atomic/buttons/PrimaryButton";

const ExclusionForm = ({
  open,
  onClose,
  exclusions,
  setFieldValue,
  values,
  index,
}) => {
  let arr = [...exclusions];
  const initialValues = {
    content: values?.content ?? "",
  };

  const validationSchema = ExclusionSchema;

  const handleSubmit = (values, { resetForm }) => {
    if (index !== null) {
      arr[index] = values;
    } else {
      arr.push(values);
    }
    setFieldValue("exclusions", [...arr]);
    onClose();
    resetForm({});
  };

  return (
    <>
      <Drawer
        title="Itenary Form"
        placement="right"
        onClose={onClose}
        open={open}
      >
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ errors, touched }) => {
            return (
              <>
                <Form>
                  <TextAreaInput
                    id="content"
                    name="content"
                    placeholder="Welcome to Kashmir"
                    labelText="Exclusion Description"
                    type="text"
                    error={errors.content}
                    touched={touched.content}
                    classes={"mt-3"}
                  />

                  <div className="mt-4">
                    <PrimaryButton
                      width={"w-full"}
                      buttonText={
                        index !== null ? "Update Exclusion" : "Add Exclusion"
                      }
                      type={"submit"}
                    />
                  </div>
                </Form>
              </>
            );
          }}
        </Formik>
      </Drawer>
    </>
  );
};
export default ExclusionForm;
